
import { SMT_MILESTONE_ACCESS } from "config";
import { SMT_PM_ACCESS } from "config";
import { FINANCIAL_PROGRESS_DASH_ACCESS } from "config";
import { VENDOR_DASH_ACCESS } from "config";
import { ISSUES_DASH_ACCESS } from "config";
import { SAFETY_DASH_ACCESS } from "config";
import { CLAIM_AND_CHANGE_ORDER_DASH_ACCESS } from "config";
import { RISK_DASH_ACCESS } from "config";
import { QUALITY_DASH_ACCESS } from "config";
import { KEY_CLEATANCE_DASH_ACCESS } from "config";
import { PROCUREMENT_DASH_ACCESS } from "config";
import { PAYMENT_TRACKER_DASH_ACCESS } from "config";
import { SMT_MANPOWERPRODUCT_ACCESS } from "config";
import { SMT_ENGINEERING_ACCESS } from "config";
import { SMT_CONSTRUCTION_ACCESS } from "config";
import { SMT_SCHEDULE_ACCESS } from "config";

const subTabsItems = {
    scheduleSubTabs: [
        { label: "Schedule Tracker", path: "schedule", index: 0, permissionKey: SMT_SCHEDULE_ACCESS },
        { label: "Construction Performance", path: "construction", index: 1, permissionKey: SMT_CONSTRUCTION_ACCESS },
        { label: "Milestone Tracking", path: "milestone", index: 2, permissionKey: SMT_MILESTONE_ACCESS },
        { label: "Engineering Performance", path: "engineering", index: 3, permissionKey: SMT_ENGINEERING_ACCESS },
        { label: "P&M", path: "pm", index: 4, permissionKey: SMT_PM_ACCESS },
        { label: "Manpower & Productivity", minWidth: '240px', path: "manpower", index: 5, permissionKey: SMT_MANPOWERPRODUCT_ACCESS },
        // { label: "Productivity", path: "productivity", index: 6 },
    ],
    costSubTabs: [
        { label: "Cost & Budget Tracker", path: "financial-progress", index: 0, permissionKey: FINANCIAL_PROGRESS_DASH_ACCESS },
        { label: "Payment Tracker", path: "payment-tracker", index: 1, permissionKey: PAYMENT_TRACKER_DASH_ACCESS },
        // { label: "Cash Flow ", path: "cash-flow", index: 2 }
    ],
    procurementSubTabs: [
        { label: "Vendor Performance Tracker", path: "vendor-performancetracker", index: 0, permissionKey: VENDOR_DASH_ACCESS },
        { label: "Procurement Status", path: "procurement", index: 1, permissionKey: PROCUREMENT_DASH_ACCESS },
        // { label: "Supply ", path: "supply", index: 2 }
    ],
    riskSubTabs: [
        { label: "Project Issue Log", path: "issues", index: 0, permissionKey: ISSUES_DASH_ACCESS },
        { label: "Key Clearances", path: "key-clearances", index: 1, permissionKey: KEY_CLEATANCE_DASH_ACCESS },
        { label: "Risk", path: "risks", index: 2, permissionKey: RISK_DASH_ACCESS },
        { label: "Safety", path: "safety", index: 3, permissionKey: SAFETY_DASH_ACCESS },
        { label: "Quality ", path: "quality", index: 4, permissionKey: QUALITY_DASH_ACCESS }
    ],
    claimAndChangeOrder: [
        { label: "Claims & Change Order", path: "claims-and-changeorder", index: 0, permissionKey: CLAIM_AND_CHANGE_ORDER_DASH_ACCESS },
    ],
};

export default subTabsItems